import { render, staticRenderFns } from "./TableParamsInfo.vue?vue&type=template&id=2a5c8c6e&scoped=true&"
import script from "./TableParamsInfo.vue?vue&type=script&lang=js&"
export * from "./TableParamsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5c8c6e",
  null
  
)

export default component.exports